import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpService } from '../../services/http/http-service.service';
import { CommonService } from '../../services/common/common.service';
import { StepConfig } from '../../entities/step-config';

@Component({
  selector: 'app-s-steps',
  templateUrl: './s-steps.component.html',
  styleUrls: ['./s-steps.component.less']
})
export class SStepsComponent implements OnInit {
  @Input() stepsObj: StepConfig;

  constructor(
    private httpService: HttpService,
    private commonService: CommonService
  ) { }
  stepsDataList = [];
  testData = [
    {
      createTime: '2020-05-13 10:00:00',
      bizTraceCorrelationCode: '跟踪码',
      bizTraceType: '执行过程跟踪|数据有效性跟踪|权限管理跟踪',
      bizTraceStep: 'step1',  // 当前步骤标题
      bizTraceMessage: '快件123456已经到达 【潮汕中心】',  // 当前步骤对应的详细信息
      bizTraceData: {
          showIcon: 'home',  // 当前步骤对应的图标
          creatorName: '用户2',  // 当前步骤由谁创建
          creatorType: '用户',  // 当前步骤创建者类型
          creatorId: '5eba3eefc1c6ae0001be31b0'
      },
      bizTraceChanges: [
          {
              fieldName: 'xxxxStatus1',
              fieldCode: 'xxxxStatusCode1',
              valueOriginal: 'xxxx1',
              valueCurrent: 'xxxxx2',
              permissionInfo: 'xx中心临时授权',
              message: '切换为2，该xxx开放访问权限'
          },
          {
              fieldName: 'xxxxStatus2',
              fieldCode: 'xxxxStatusCode2',
              valueOriginal: 'xxxx2',
              valueCurrent: 'xxxxx3',
              permissionInfo: 'xx用户组固定授权',
              message: '切换为3，仅admin可见'
          }
      ],
      bizTraceActions: [  // 操作：按钮组
          {
              actionName: '查看那位仁兄',
              actionType: 'Goto',  // 路由跳转
              actionUrl: 'http://biz/view/123456',
              actionContent: {a: 1, b: 2}
          },
          {
              actionName: '拨打成都调度中心电话',
              actionType: 'Pop',  // modal
              actionUrl: 'http://biz/related/123456',
              actionContent: {a: 1, b: 2}
          },
          {
              actionName: '转发一把',
              actionType: 'PostData',  // post请求
              actionUrl: 'http://biz/relay/123456',
              actionContent: {a: 1, b: 2}
          }
      ]
  },
  {
    createTime: '2020-05-11 10:00:00',
    bizTraceCorrelationCode: '跟踪码',
    bizTraceType: '执行过程跟踪|数据有效性跟踪|权限管理跟踪',
    bizTraceStep: 'step2',  // 当前步骤标题
    bizTraceMessage: '快件123456已经到达 【潮汕中心】',  // 当前步骤对应的详细信息
    bizTraceData: {
        showIcon: '',  // 当前步骤对应的图标
        creatorName: '用户1',  // 当前步骤由谁创建
        creatorType: '系统',  // 当前步骤创建者类型
        creatorId: '5eba3eefc1c6ae0001be31b0'
    },
    bizTraceChanges: [
        {
            fieldName: 'xxxxStatus1',
            fieldCode: 'xxxxStatusCode1',
            valueOriginal: 'xxxx1',
            valueCurrent: 'xxxxx2',
            permissionInfo: 'xx中心临时授权',
            message: '切换为2，该xxx开放访问权限'
        },
        {
            fieldName: 'xxxxStatus2',
            fieldCode: 'xxxxStatusCode2',
            valueOriginal: 'xxxx2',
            valueCurrent: 'xxxxx3',
            permissionInfo: 'xx用户组固定授权',
            message: '切换为3，仅admin可见'
        }
    ],
    bizTraceActions: [  // 操作：按钮组
        {
            actionName: '查看那位仁兄',
            actionType: 'Goto',  // 路由跳转
            actionUrl: 'http://biz/view/123456',
            actionContent: {a: 1, b: 2}
        },
        {
            actionName: '拨打成都调度中心电话',
            actionType: 'Pop',  // modal
            actionUrl: 'http://biz/related/123456',
            actionContent: {a: 1, b: 2}
        },
        {
            actionName: '转发一把',
            actionType: 'PostData',  // post请求
            actionUrl: 'http://biz/relay/123456',
            actionContent: {a: 1, b: 2}
        }
    ]
},
];

  ngOnInit(): void {
    this.setDefaultAttrs();
    // 测试数据
    // this.initStepsData(this.testData);
    if (this.stepsObj.data) {
      this.stepsDataList = [...this.stepsObj.data];
    }
    // 异步数据
    this.getStepsData();
  }
  async getStepsData() {
    if (this.stepsObj.url) {
      const res = await this.httpService.httpGet(this.stepsObj.url, this.stepsObj.params).toPromise();
      if (res.code === 1) {
        this.initStepsData(res.data.data);
      }
    }
  }

  initStepsData(data) {
    this.stepsDataList = [];
    if (!data.length) { return; }
    data.forEach((item, index) => {
      const comSubTitle = `该信息由${item.bizTraceData.creatorName}(${item.bizTraceData.creatorType})于${item.createTime}创建`;
      const temp = {
        title: item.bizTraceStep || '', subTitle: comSubTitle,
        icon: item.bizTraceData.showIcon || 'up-circle',
        description: {title: item.bizTraceMessage, btnGroup: []}
      };
      if (item.bizTraceActions && item.bizTraceActions.length) {
        item.bizTraceActions.forEach(b => {
          const btnGroup = {actionName: b.actionName, actionType: b.actionType, actionUrl: b.actionUrl, actionContent: b.actionContent};
          temp.description.btnGroup.push(btnGroup);
        });
      }
      this.stepsDataList.push(temp);
    });
  }

  btnClick(obj) {

  }
  setDefaultAttrs() {}

}
